export const userConstants = {
    LOAD_SETTINGS_SUCCESS: 'LOAD_SETTINGS_SUCCESS',
    LOAD_SETTINGS_FAILURE: 'LOAD_SETTINGS_FAILURE',
    RESET_SETTINGS: 'RESET_SETTINGS',
    SWITCH_CLIENT_SUCCESS: 'SWITCH_CLIENT_SUCCESS',
    UPDATE_PAYMENT_PLAN: 'UPDATE_PAYMENT_PLAN'
};
